import { Alert, Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function InclusionHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();
  const cards = [
    {
      path: '/education/inclusion/accommodations',
      title: t('inclusionAccommodations'),
      desc: t('inclusionAccommodationsIntro'),
    },
    {
      path: '/education/inclusion/screenings',
      title: t('inclusionScreenings'),
      desc: t('inclusionScreeningsIntro'),
    },
  ];

  return (
    <EducationPageChrome title={t('inclusion')} description={t('inclusionIntro')}>
      <Alert type="info" showIcon style={{ marginBottom: 16 }} message={t('inclusionNonDiagnosticHint')} />
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
